/*eslint-disable */
import React, { Component } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import RateChartModal from "../../../components/vendorComponent/rateChartModal";
import BillingPartyBranch from "./branchEdit";
import ReadAxios from "../../../components/axiosComponent/read";
import { isEmpty } from "lodash";
import Name from "../../../components/vendorComponent/name";
import { translate } from "react-i18next";
import DeleteModal from "../../../components/common/deleteModal";
import EditRateChart from "../../../components/common/rateChartEdit";
import DeleteAxios from "../../../components/axiosComponent/delete";
import BranchDetailModal from "./branchdetailmodal";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { connect } from "react-redux";
import Axios from "axios";
import { LOCAL_STORAGE } from "../../../utils/constant";
import cogoToast from "cogo-toast";
import ConfirmationModal from "../../../components/common/confirmationModal";
import ImportModal from "../../../components/titleBar/importModal";
export class BranchTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorRateChart: [],
      deleteModalOpen: false,
      ratechart: false,
      edit: {},
      billingPartyBranchToDelete:{
        name:'',
        id:''
      },
      importModalOpen : false
    };
  }

  componentDidMount() {
  }

  setDeafultValue = (masterRoute, deafultValue) => {
    ReadAxios({
      url: `${masterRoute}/${deafultValue}`,
    })
      .then((res) => {
        console.log(res.data.resultSet);
      })
      .catch((err) => console.log(err));
  };

  BranchEditModal = (e, data) => {
    if (data.add_mode === 'add') {
      this.setState({
        branchmodal: true,
        editUserInputs: false,
        edit: null,
      })
    } else if (data.add_mode === 'edit') {
      this.setState({
        branchmodal: true,
        editUserInputs: true,
        edit: { ...data.user_items },
      })
    } else {
      this.setState({
        deleteModalOpen: true,
        edit: { ...data.user_items },
      })
    }
  };

  BranchModalClose = () => {
    this.setState({ branchmodal: false });
    window.location.reload()
  };
  openDeleteModal = (object = {}) => {
    this.setState({ deleteModalOpen: true, billingPartyBranchToDelete:{id:object.billingPartyBranchId, name:object.billingPartyBranchName}});
  }
  submitDelete = (object = {}) => {
    const data = {
      customerNumber: LOCAL_STORAGE.customerNo,
      userId: LOCAL_STORAGE.userId
    };
    Axios.delete(`${process.env.REACT_APP_MASTER_API}/billing_party_branch/${this.state.billingPartyBranchToDelete.id}`, {
      data: data,
      headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` }
    })
      .then(response => {
        if (response.data.status === 200) {
          cogoToast.success(`${this.state.billingPartyBranchToDelete.name} is deleted.`, { position: "top-right" }).then(()=>{
            window.location.reload();
          })
        }else{
          cogoToast.error(response.data.message, { position: "top-right" }).then(()=>{
            window.location.reload();
          })
        }
      })
      .catch((err) => {
          cogoToast.error(`Unable to Delete ${this.state.billingPartyBranchToDelete.name}`, { position: "top-right" })
      });
  };
  closeDeleteModal = () => {
    this.setState({ deleteModalOpen: false });
  };

  getcities = (id) => {
    ReadAxios({ url: `cityMaster/${id}` })
      .then((res) => {
        let city = res.data.resultSet[0].cityName;
        return city;
      })
      .catch((err) => {
        return "NA";
      });
  }

  confirmDelete = () => {
    DeleteAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${this.state.edit.vendor_rate_id}`,
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: "Vendor rate deleted.",
        };
        this.props.successAlertDispatcher(alert);
        this.closeDeleteModal();
        this.getVendorRateChart();
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to delete vendor rate.",
        };
        console.log(err);
        this.props.errorAlertDispatcher(alert);
        this.closeDeleteModal();
      });
  };

  handleImportOpen = ()=>{
    this.setState({importModalOpen : true})
  }

  handleImportClose = ()=>{
    window.location.reload()
  }

  updatePage = () => {
    this.BranchModalClose();
    window.location.reload();
  };

  render() {
    const { t } = this.props;
    return (
      <>
        {true && (
          <div className="mb-3">
            <Table stackable size="small" selectable>
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="7" className="p-bold-600">
                    {t('title')}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                  <button
                    type="button"
                    onClick={() => this.handleImportOpen()}
                    className="grey-btn">
                    <i class="fas fa-file-import mr-1"></i>
                    {"Import"}
                  </button>
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={this.BranchEditModal}
                    >
                      <Icon name="plus" /> {t('add_title')}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                <Table.HeaderCell className="p-bold-500">
                    {t("table_header.branch_code")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.branch")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.state")}
                  </Table.HeaderCell> */}
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.pan_number")}
                  </Table.HeaderCell> */}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.gst_number")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.address")}
                  </Table.HeaderCell>
                  {/* <Table.HeaderCell className="p-bold-500">
                    {t("table_header.city")}
                  </Table.HeaderCell> */}
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.pincode")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t("table_header.more_detail")}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t('table_header.edit') || 'Edit'}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {t('table_header.delete') || 'Delete'}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {this.props.BranchList && this.props.BranchList.length > 0 ? (
                this.props.BranchList.map((object, index) => (
                  <Table.Row key={index}>
                    <Table.Cell className="fixedLength150">{object.billingPartyBranchCode ? object.billingPartyBranchCode : "NA"}</Table.Cell>
                    <Table.Cell className="fixedLength150">{object.billingPartyBranchName ? object.billingPartyBranchName : "NA"}</Table.Cell>
                    {/* <Table.Cell>{object.vendorBranchStateId ? object.vendorBranchStateId : "NA"}</Table.Cell> */}
                    {/* <Table.Cell>{object.vendorBranchPAN ? object.vendorBranchPAN : "NA"}</Table.Cell> */}
                    <Table.Cell>{object.billingPartyBranchGst ? object.billingPartyBranchGst : "NA"}</Table.Cell>
                    <Table.Cell className="fixedLength150">{object.billingPartyBranchAddress ? object.billingPartyBranchAddress : "NA"}</Table.Cell>
                    {/* <Table.Cell>{object.vendorBranchCity ? this.getcities(object.vendorBranchCity) : "NA"}</Table.Cell> */}
                    <Table.Cell>{object.billingPartyBranchPincode ? object.billingPartyBranchPincode : "NA"}</Table.Cell>
                    <Table.Cell><BranchDetailModal id={object.vendorBranchId} data={object} /></Table.Cell>
                    <Table.Cell><Button user_items={object} type="button" add_mode="edit" onClick={this.BranchEditModal} size="mini" color="green" basic icon> <Icon name="edit" /> </Button> </Table.Cell>
                    <Table.Cell><Button type="button" user_items={object} add_mode="delete" onClick={() => this.openDeleteModal(object)} size="mini" color="blue" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{t("records" || "No Record(s) Found")}</Table.Cell>
                </Table.Row>
              )}
            </Table>
          </div>
        )}
        {this.state.deleteModalOpen && (
          <ConfirmationModal
            open={this.state.deleteModalOpen}
            handleCancel={this.closeDeleteModal}
            handleConfirm={this.submitDelete}
          />
        )}

        {/* <DeleteModal
          deleteOpen={this.state.deleteModalOpen}
          CloseModal={this.closeDeleteModal}
          ConfirmDeleteRow={this.confirmDelete}
        /> */}
        <BillingPartyBranch
          billingPartyID={this.props.billingPartyID}
          branchModal={this.state.branchmodal}
          CloseModal={this.BranchModalClose}
          vendor_code={this.props.vendor_code}
          editData={this.state.edit}
          onFormSubmit={this.updatePage}
          editDataPass={this.props.editData}
        />
        <ImportModal
        openBox={this.state.importModalOpen}
        handleClose={this.handleImportClose}
        fileName={this.props.fileName}
        baseURL={this.props.importBaseUrl}
        masterIdName={this.props.masterIdName || null}
        masterIdValue={this.props.masterIdValue || null}
        />
      </>
    );
  }
}

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('branch')(BranchTable));
